import { useTranslation } from "react-i18next"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { FormError } from "@/components/FormError"
import { noAutofillProps } from "@/lib/form"

export interface LocationFormData {
  name: string
  street: string
  city: string
  state: string
}

export const emptyLocationFormData: LocationFormData = {
  name: "",
  street: "",
  city: "",
  state: "",
}

export interface LocationFormErrors {
  name?: string | string[]
  street?: string | string[]
  city?: string | string[]
  state?: string | string[]
}

interface LocationFormProps {
  data: LocationFormData
  errors: LocationFormErrors
  onChange: (field: keyof LocationFormData, value: string) => void
  idPrefix: string
}

export function LocationForm({ data, errors, onChange, idPrefix }: LocationFormProps) {
  const { t } = useTranslation()

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-4">
      <div className="space-y-2 sm:col-span-2">
        <Label htmlFor={`${idPrefix}-name`}>{t("locations.nameLabel")} *</Label>
        <Input
          id={`${idPrefix}-name`}
          value={data.name}
          onChange={(e) => onChange("name", e.target.value)}
          placeholder={t("locations.namePlaceholder")}
          required
          {...noAutofillProps}
        />
        <FormError error={errors.name} />
      </div>
      <div className="space-y-2 sm:col-span-2">
        <Label htmlFor={`${idPrefix}-street`}>{t("locations.streetLabel")}</Label>
        <Input
          id={`${idPrefix}-street`}
          value={data.street}
          onChange={(e) => onChange("street", e.target.value)}
          placeholder={t("locations.streetPlaceholder")}
          {...noAutofillProps}
        />
        <FormError error={errors.street} />
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-city`}>{t("locations.cityLabel")}</Label>
        <Input
          id={`${idPrefix}-city`}
          value={data.city}
          onChange={(e) => onChange("city", e.target.value)}
          placeholder={t("locations.cityPlaceholder")}
          {...noAutofillProps}
        />
        <FormError error={errors.city} />
      </div>
      <div className="space-y-2">
        <Label htmlFor={`${idPrefix}-state`}>{t("locations.stateLabel")}</Label>
        <Input
          id={`${idPrefix}-state`}
          value={data.state}
          onChange={(e) => onChange("state", e.target.value)}
          placeholder={t("locations.statePlaceholder")}
          {...noAutofillProps}
        />
        <FormError error={errors.state} />
      </div>
    </div>
  )
}
